import { useEffect, useState } from "react"
import { useQueryClient } from "react-query"

import { User } from "sharedTypes"
import confirmEmailTokenAndToast from "services/confirmEmailToken"

type ConfirmEmailTokenResult = {
  data: User
  priorConfirmed: boolean
}

const useConfirmEmailToken = (
  {
    confirmationToken,
    enabled,
  }: {
    confirmationToken: string
    enabled: boolean
  },
) => {
  const queryClient = useQueryClient()
  const [isConfirming, setIsConfirming] = useState(false)
  const [isFinished, setIsFinished] = useState(!enabled)
  const [result, setResult] = useState<ConfirmEmailTokenResult | null | undefined>(undefined)

  useEffect(() => {
    if (!enabled || !confirmationToken) {
      setIsConfirming(false)
      setIsFinished(true)
      setResult(undefined)

      return undefined
    }

    setIsConfirming(true)
    setIsFinished(false)

    let isActive = true

    confirmEmailTokenAndToast({
      confirmationToken,
      queryClient,
    })
      .then((r) => {
        if (!isActive) return
        setResult(r ?? null)
      })
      .finally(() => {
        if (!isActive) return
        setIsConfirming(false)
        setIsFinished(true)
      })

    return () => {
      isActive = false
    }
  }, [confirmationToken, enabled, queryClient])

  return { isConfirming, isFinished, result }
}

export default useConfirmEmailToken
